import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';

/** Read the staff session from AuthProvider. Throws if used outside the provider. */
export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return ctx;
}
